import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { LoginType } from '../types';

export const useLogCompleteSocialLogin = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ isNew, type }: { isNew: boolean; type: LoginType }) => {
      logAnalyticsEvent({
        name: isNew ? 'COMPLETE_SIGN_UP' : 'COMPLETE_SIGN_IN',
        channel: ['firebase', 'amplitude', 'ablylog'],
        analytics: {
          ACCOUNT_TYPE: type.toUpperCase(),
        },
      });
    },
    [logAnalyticsEvent],
  );
};
